import { computed } from 'vue';
import { useInfiniteVueQuery } from '@libs/use';
import { Deposit, DepositsQuery } from '@libs/api-reference';

import * as API from '../requests';
import { CASH_QUERY_KEYS } from '../constants';

export default function useGetDepositReceiptsInfiniteQuery() {
  const {
    result,
    isPending: isLoadingDepositReceipts,
    execute: getDepositReceipts,
    reset: resetDepositReceipts,
    ...query
  } = useInfiniteVueQuery<DepositsQuery, Deposit>(
    ({ pageNumber, pageSize }) =>
      API.getLastDepositReceipts({
        pageNumber,
        pageSize,
      }),
    {
      key: CASH_QUERY_KEYS.depositReceipt,
    }
  );

  const depositReceipts = computed(() => result.value || []);

  return {
    depositReceipts,
    isLoadingDepositReceipts,
    getDepositReceipts,
    resetDepositReceipts,
    ...query,
  };
}
